import React from "react"
import { Link } from "gatsby"
import "../../styles/global.css"

export default function Logo() {
  return (
    <Link to="/" className="logo" aria-label="Home">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="95.704"
        height="57.841"
        viewBox="0 0 95.704 57.841"
      >
        <g id="layer1" transform="translate(-6.143 -147.801)">
          <g id="g1326" transform="translate(9.643 147.801)">
            <g id="g1267-1" transform="translate(0 0)">
              <path
                id="path817-8"
                d="M98.16,167.7v57.826"
                transform="translate(-90.413 -167.698)"
                fill="none"
                stroke="#6b807c"
                strokeWidth="3.5"
              />
              <path
                id="path817-9-2"
                d="M120.836,176.06,95.8,190.516l25.039,14.456"
                transform="translate(-95.797 -148.647)"
                fill="none"
                stroke="#6b807c"
                strokeWidth="3.5"
              />
            </g>
            <g id="g1267-3-9" transform="translate(92.204 31.922) rotate(90)">
              <path
                id="path817-45-9"
                d="M0,0V57.826"
                transform="translate(7.747)"
                fill="none"
                stroke="#6b807c"
                strokeWidth="3.5"
              />
              <path
                id="path817-9-0-9"
                d="M25.039,0,0,14.456,25.039,28.913"
                transform="translate(0 27.413)"
                fill="none"
                stroke="#6b807c"
                strokeWidth="3.5"
              />
            </g>
          </g>
        </g>
      </svg>
    </Link>
  )
}
